import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface MineralCardProps {
  name: string;
  description: string;
  image: string;
  price: string;
  category: string;
}
export function MineralCard({
  name,
  description,
  image,
  price,
  category
}: MineralCardProps) {
  return <motion.div className="group relative bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer h-[500px]" whileHover={{
    y: -10
  }} data-id="element-151">
      {/* Image Container */}
      <div className="absolute inset-0 w-full h-full" data-id="element-152">
        <img src={image} alt={name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-153" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" data-id="element-154" />
      </div>

      {/* Content Overlay */}
      <div className="absolute inset-0 p-8 flex flex-col justify-end text-white" data-id="element-155">
        <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-156">
          <span className="inline-block px-3 py-1 bg-drc-blue/90 text-xs font-semibold tracking-wider uppercase rounded-full mb-3 backdrop-blur-sm" data-id="element-157">
            {category}
          </span>
          <h3 className="text-2xl font-bold mb-2" data-id="element-158">{name}</h3>
          <p className="text-gray-300 mb-4 line-clamp-2 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100" data-id="element-159">
            {description}
          </p>

          <div className="flex items-center justify-between mt-4 border-t border-white/20 pt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-200" data-id="element-160">
            <span className="text-xl font-semibold" data-id="element-161">{price}</span>
            <span className="flex items-center text-sm font-medium text-drc-yellow group-hover:text-yellow-300" data-id="element-162">
              View Details <ArrowRight size={16} className="ml-2" data-id="element-163" />
            </span>
          </div>
        </div>
      </div>
    </motion.div>;
}